module.exports = __webpack_public_path__ + "img/fingers-meet.6ff77a68.png";